import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import SiteNavItem from './SiteNavItem';

import styles from './SiteNav-style.scss';

const SUB_NAV_FETCH_TRESHOLD = 250;

export function SiteNav({ viewer, relay }) {
    const navigation = get(viewer, 'tradeNavigation') || get(viewer, 'navigation') || null;
    const [fetchSubNav, setFetchSubNav] = useState(false);
    const mousePositionObserver = useRef(event => {
        if (event.clientY < SUB_NAV_FETCH_TRESHOLD) {
            setFetchSubNav(true);
        }
    });

    // Handle refetch
    useEffect(() => {
        if (fetchSubNav) {
            window.removeEventListener('mousemove', mousePositionObserver.current);
            relay.refetch({ fetchSubNav: true }, null);
        }
    }, [fetchSubNav, relay]);

    // Add mousemove event listener
    useEffect(() => {
        const observer = mousePositionObserver.current;

        window.addEventListener('mousemove', observer);

        // clean up function witch should run on un-mount
        return function cleanup() {
            window.removeEventListener('mousemove', observer);
        };
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.items}>
                {(get(navigation, 'modules') || []).map(module => {
                    return <SiteNavItem key={module.serviceId} navigationModule={module} />;
                })}
            </div>
        </div>
    );
}

SiteNav.propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object,
};

export default createRefetchContainer(
    SiteNav,
    {
        viewer: graphql`
            fragment SiteNav_viewer on Viewer {
                navigation: navigation(rootId: $previewKey) @include(if: $fetchNav) {
                    modules {
                        ...SiteNavItem_navigationModule
                        serviceId
                    }
                }
                tradeNavigation: navigation(rootId: $previewKey, userType: TRADE)
                    @include(if: $fetchTradeNav) {
                    modules {
                        ...SiteNavItem_navigationModule
                        serviceId
                    }
                }
            }
        `,
    },
    graphql`
        query SiteNavRefetchQuery(
            $fetchNav: Boolean!
            $fetchTradeNav: Boolean!
            $fetchSubNav: Boolean!
            $previewKey: String = ""
        ) {
            viewer {
                ...SiteNav_viewer
            }
        }
    `
);
